import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Form, FormGroup, Label, Input } from "reactstrap";
import PropTypes from "prop-types";
import Submit from "../../components/Submit";
import ContentBox from "../../components/ContentBox";
import { Creators as UserCreators } from "../../store/ducks/user";

class UserConfirmation extends Component {
  static propTypes = {
    getUserConfirmationRequest: PropTypes.func.isRequired,
    updateUserConfirmation: PropTypes.func.isRequired,
    user: PropTypes.shape.isRequired
  };

  componentWillMount() {
    this.props.getUserConfirmationRequest(this.props.match.params.token);
  }

  submitHandle = (e, update) => {
    e.preventDefault();
    var email = e.target.email.value.trim();
    this.props.updateUserConfirmation(e.target.token.value, e.target.id.value, e.target.nickname.value.trim(), email, e.target.password.value.trim());
  };

  render() {
    return (
      <Fragment>
        <ContentBox title="Confirmação de Assinatura">
          <Form onSubmit={e => this.submitHandle(e, this.props.update)}>
            <Input
              type="hidden"
              name="token"
              id="token"
              defaultValue={this.props.match.params.token}
            />
            <Input
              type="hidden"
              name="id"
              id="userId"
              defaultValue={this.props.user.id}
            />
            <FormGroup>
              <Input
                placeholder="Como gostaria de ser chamado"
                name="nickname"
                defaultValue={this.props.user.nickname}
                required
              />
            </FormGroup>
            <FormGroup>
              <Input
                placeholder="Email"
                type="email"
                name="email"
                defaultValue={this.props.user.email} required
              />
            </FormGroup>
            <FormGroup>
              <Input
                placeholder="Escolha uma Senha"
                type="password"
                name="password"
                required
              />
            </FormGroup>

            <Submit loading={this.props.user.updateLoading} name="Salvar" />
          </Form>

        </ContentBox>
      </Fragment>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({ ...UserCreators }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(UserConfirmation);



// WEBPACK FOOTER //
// ./src/pages/userConfirmation/index.js